"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class DocumentWithContent {
}
exports.default = DocumentWithContent;
//# sourceMappingURL=DocumentWithContent.js.map